import { Observable } from "rxjs";
import { StateService } from "./stateService";

export interface ErrorState {
    endpoint: string;
    error: string;
    userError: string
    isError: boolean;
  }
  
const initialState: ErrorState = {
    endpoint: "",
    error: "",
    userError: "",
    isError: false,
  };

export function CreateUserError(resource: string, errorMessage: string) : ErrorState {
    return {
        endpoint: resource,
        error: "",
        userError: errorMessage,
        isError: true
    }
}




export class ErrorStateServiceForRoot extends StateService<ErrorState>{
    public static service: ErrorStateServiceForRoot;

    public static getErrorStateService() : ErrorStateServiceForRoot {
        if ( this.service === undefined) {
            this.service = new ErrorStateServiceForRoot();
        }
        return this.service;
    }

    private constructor() {
        super(initialState);
    }
    
    public subscription(): Observable<ErrorState> {
        return this.subscribe();
    }

    public changeErrorState(error: ErrorState) : void {
        this.changeState(error);
    }

    public resetErrorState() : void {
        const error = {
            endpoint: "",
            error: "",
            userError: "",
            isError: false
        }

        this.changeState(error);
    }

    public get state(): ErrorState {
        return this.state;
    }
}